module.exports = __webpack_public_path__ + "static/img/wat.4c33b31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wat.png
// module id = sgsM
// module chunks = 0